"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.887 15.22a1.466 1.466 0 0 1 2.546 0l1.997 3.483c.56.975-.135 2.209-1.273 2.209h-3.994c-1.138 0-1.832-1.234-1.273-2.21zm1.332.697a.066.066 0 0 0-.117 0l-1.997 3.482a.1.1 0 0 0-.011.039q0 .017.011.039a.1.1 0 0 0 .025.027.06.06 0 0 0 .033.008h3.994a.06.06 0 0 0 .033-.008.1.1 0 0 0 .026-.027.1.1 0 0 0 .011-.039.1.1 0 0 0-.011-.039zM11.855 4.4a1.943 1.943 0 1 0 0 3.885 1.943 1.943 0 0 0 0-3.885M8.513 6.343a3.343 3.343 0 1 1 6.685 0 3.343 3.343 0 0 1-6.685 0m-5.14 9.927a1.7 1.7 0 0 1 1.7-1.7h3.03a1.7 1.7 0 0 1 1.7 1.7v3.03a1.7 1.7 0 0 1-1.7 1.7h-3.03a1.7 1.7 0 0 1-1.7-1.7zm1.7-.3a.3.3 0 0 0-.3.3v3.03a.3.3 0 0 0 .3.3h3.03a.3.3 0 0 0 .3-.3v-3.03a.3.3 0 0 0-.3-.3z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.155 11.35h-2.57a2.7 2.7 0 0 0-2.7 2.7v1.446h1.4V14.05a1.3 1.3 0 0 1 1.3-1.3h6.57a1.3 1.3 0 0 1 1.3 1.3v1.446h1.4V14.05a2.7 2.7 0 0 0-2.7-2.7h-2.6V9.09h-1.4z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=PlanManagerIcon24.js.map